export default __webpack_public_path__ + "static/media/our-clients.5daf3a53.png";